import React, { useContext } from "react";
import { GoogleLogin } from "react-google-login";
import { SignInContext } from "./context/SignInContext";
import { UserContext } from "./context/UserContext";
import styled from "styled-components";
import { GoogleButton } from "./GlobalStyles";
import { FcGoogle } from "react-icons/fc";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const SignInButton = () => {
	const { setSignedIn, setGoogleProfile } = useContext(SignInContext);
	const { setUser } = useContext(UserContext);

	const onSuccess = (response) => {
		// console.log("[Login success] googleUser:", response.profileObj);
		setSignedIn(true);
		setGoogleProfile(response.profileObj);
		setUser(response.profileObj.email);
	};

	const onFailure = (response) => {
		console.log("[Login failed] res:", response);
	};

	return (
		<>
			<GoogleLogin
				clientId={clientId}
				render={(renderProps) => (
					<Button onClick={renderProps.onClick}>
						<FcGoogle />
						sign in
					</Button>
				)}
				onSuccess={onSuccess}
				onFailure={onFailure}
				cookiePolicy={"single_host_origin"}
				isSignedIn={true}
			/>
		</>
	);
};

export default SignInButton;

const Button = styled(GoogleButton)``;
